export default __webpack_public_path__ + "static/media/OC-bg.f59997f3.jpg";